<template>
  <div :id="chartId">
  </div>
</template>

<script>
  export default {
    name: 'ChecklistBarChart',
    props: {
      chartId: {
        type: String,
        required: true
      },
      checklistName: {
        type: String,
        required: true
      },
      checklistData: {
        type: Array,
        required: true
      }
    },
    data: function () {
      return {
        highCharts: null
      }
    },
    watch: {
      checklistData() {
        this.renderChart()
      },
      highCharts() {
        if (this.highCharts) {
          this.renderChart()
        }
      }
    },
    mounted() {
      import(/* webpackChunkName: "highcharts" */'highcharts').then(({ default: hc }) => {
        this.highCharts = hc
      })
    },
    methods: {
      renderChart() {
        const data = this.checklistData
        const questions = data.map(item => item.question)
        const yesData = data.map(item => item.yes)
        const noData = data.map(item => item.no)
        const naData = data.map(item => item.na)
        const notAnsweredData = data.map(item => item.notAnswered)

        const calculateChartHeight = (questions) => {
          const baseHeight = 200 // Minimum height
          const barHeight = 65 // Height per bar
          const marginPerBar = 20 // Spacing between bars
          const headerHeight = 60 // Space for title and legend

          const contentHeight = (questions.length * (barHeight + marginPerBar)) + headerHeight
          return Math.max(baseHeight, contentHeight)
        }
        const chartHeight = calculateChartHeight(questions)

        this.highCharts.chart(this.chartId, {
          credits: {
            enabled: false
          },
          chart: {
            type: 'bar',
            height: chartHeight
          },
          title: {
            text: this.checklistName,
            style: {
              fontSize: '16px',
              fontFamily: 'Roboto, sans-serif'
            }
          },
          xAxis: {
            categories: questions
          },
          yAxis: {
            min: 0
          },
          legend: {
            reversed: true
          },
          plotOptions: {
            bar: {
              cursor: 'pointer'
            },
            series: {
              stacking: 'normal',
              dataLabels: {
                enabled: false,
                formatter: function () {
                  if (this.y !== 0) {
                    return this.y
                  }
                }
              }
            }
          },
          series: [
            { name: 'Not Answered', data: notAnsweredData, color: '#9E9E9E' },
            { name: 'N/A', data: naData, color: '#f9d25d' },
            { name: 'No', data: noData, color: '#f56c6c' },
            { name: 'Yes', data: yesData, color: '#7cbe5f' }
          ]
        })
      }
    }
  }
</script>

<style scoped>
  .highcharts-container {
    width: 100% !important;
    height: 100% !important;
  }

  .highcharts-root {
    width: 100% !important;
    height: 100% !important;
  }

  .hiddenVisibility {
    visibility: hidden;
  }
</style>
